import { render, staticRenderFns } from "./JournalPapers.vue?vue&type=template&id=b59a3d7c"
import script from "./JournalPapers.vue?vue&type=script&lang=js"
export * from "./JournalPapers.vue?vue&type=script&lang=js"
import style0 from "./JournalPapers.vue?vue&type=style&index=0&id=b59a3d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports